import React from 'react';
import TooltipModal from '../components/TooltipModal';
import { Tooltip_t } from '../components/common/tooltips/tooltips';

interface TooltipModalWrapperProps {
  visible: boolean;
  tooltipData: Tooltip_t;
  onClose: () => void;
}

const TooltipModalWrapper: React.FC<TooltipModalWrapperProps> = ({ visible, tooltipData, onClose }) => (
  <TooltipModal 
    tooltipData={tooltipData} 
    visible={visible} 
    onClose={onClose} 
  />
);

export default TooltipModalWrapper;
